import $ from 'jquery';

/*
 * In this module, we extend Select2 to fix some bugs and provide customizations and features that are specific to our
 * application.
 *
 * To do so in a clean way, we use the Select2 'Adapters and Decorators' system, as documented here:
 * @see https://select2.org/advanced/adapters-and-decorators
 */
$.fn.select2.amd.define('select2.extension', [
    'jquery',
    'select2/defaults',
    'select2/utils',
], function ($, Defaults, Utils) {
    /*
     * Extension for Selection adapters.
     */
    const SelectionExtension = function () {};

    SelectionExtension.prototype.bind = function (decorated, container, $container) {
        const self = this;

        decorated.call(this, container, $container);

        // jquery-validation integration: trigger validation on change.
        this.$element.on('change', function () {
            self.$element.trigger('focusout.validate');
        });

        // Fix a bug that happens when user clicks on the 'clear all' button of a Select2 component while another
        // Select2 component had focus.
        //
        // Because the allowClear decorator calls stopPropagation() on the 'mousedown' event, the Select2 component
        // that loses focus does not close properly.
        // https://github.com/select2/select2/blob/develop/src/js/select2/selection/allowClear.js#L45
        //
        // The trick below fixes that.
        this.$selection.on('mousedown', '.select2-selection__clear', function () {
            $('body').trigger('mousedown.select2', {target: $container});
        });
    };

    SelectionExtension.prototype.update = function (decorated, data) {
        decorated.call(this, data);

        // Add the 'select2-selection--clearable' class to selection elements that have a visible 'clear all' button.
        // This allows us to apply specific CSS style on them.
        //
        // This is actually a backport: most recent version of Select2 does that already.
        // https://github.com/select2/select2/commit/27345381b1e868934f176cb6c223298a4bc6c467#diff-9d923405d022ae295e71a6c31f17d56775bd347e2d75fad5acafb1b291944d09
        // But unfortunately the version of Select2 that is bundled in AppStack does not.
        this.$selection.toggleClass(
            'select2-selection--clearable',
            this.$selection.find('.select2-selection__clear').length > 0,
        );
    };

    /*
     * Extension for MulipleSelection adapter.
     */
    const MultipleSelectionExtension = function () {};

    MultipleSelectionExtension.prototype.bind = function (decorated, container, $container) {
        const self = this;

        decorated.call(this, container, $container);

        // Clicking on the 'remove' button of a selected element in a 'multiple selections' component would toggle the
        // whole component. Prevent that from happening:
        this.$selection.on('click', '.select2-selection__choice__remove', function (event) {
            event.stopPropagation();
        });

        // When 'closeOnSelect' option is false or CTRL key is pushed while an option is selected or unselected, the
        // search input loses focus.
        //
        // Because the results component can be controlled from search input using keyboard, we'd rather have the
        // search input keep the focus.
        container.on('select', function () {
            self.$search.trigger('focus');
        });
        container.on('unselect', function () {
            self.$search.trigger('focus');
        });
    };

    // When option 'allowClear' is combined with 'multiple', the BACKSPACE key has the effect of removing ALL selected
    // items.
    //
    // That's very counter-intuitive for user, so we'd rather have this feature disabled. Clearing the whole selection
    // remains possible by mouse but the BACKSPACE key will only remove the last selected item (as it does when
    // 'allowClear' option is false).
    MultipleSelectionExtension.prototype._handleKeyboardClear = function () {};

    // Also, let's customize the way removing the last selected item works. By default the search input is automatically
    // filled with the value that was removed.
    // https://github.com/select2/select2/blob/0a186ebb4875b080f70e5f48d957f025e97194f5/src/js/select2/selection/search.js#L218-L225
    //
    // We actually don't want that.
    MultipleSelectionExtension.prototype.searchRemoveChoice = function (decorated, item) {
        if (this.options.get('tags')) {
            // Default behavior seems more logical for Select2 with the 'tags' option. Keep it as it is.
            decorated.call(this, item);
        } else {
            this.trigger('unselect', {data: item});
        }
    };

    /*
     * Extension for DropdownSearch decorator.
     */
    const DropdownSearchExtension = function () {};

    DropdownSearchExtension.prototype.bind = function (decorated, container, $container) {
        const self = this;

        decorated.call(this, container, $container);

        // When 'closeOnSelect' option is false or CTRL key is pushed while an option is selected or unselected, the
        // search input loses focus.
        //
        // Because the results component can be controlled from search input using keyboard, we'd rather have the
        // search input keep the focus.
        //
        // Also, the changes below seem to mitigate this bug: https://github.com/select2/select2/issues/5993
        container.listeners.focus.pop();
        container.on('select', function () {
            self.$search.trigger('focus');
        });
        container.on('unselect', function () {
            self.$search.trigger('focus');
        });
    };

    /*
     * Extension for Results adapter.
     */
    const ResultsExtension = function () {};

    /*
     * Dummy Results adapter for noDropdown mode. (see below how noDropdown works)
     */
    const DummyResultsAdapter = function () {
        DummyResultsAdapter.__super__.constructor.call(this);

        this.data = null;
    }

    Utils.Extend(DummyResultsAdapter, Utils.Observable);

    DummyResultsAdapter.prototype.render = function () {};

    DummyResultsAdapter.prototype.bind = function (container) {
        const self = this;

        container.on('results:all', function (params) {
            self.data = params.data.results.length ? params.data.results[0] : null;
        });

        container.on('results:select', function () {
            container.trigger('close');
        });

        container.on('close', function () {
            if (self.data) {
                container.trigger('select', {data: self.data});
            }
        });

        container.on('clear', function () {
            self.data = null;
        });
    };

    DummyResultsAdapter.prototype.position = function () {};

    DummyResultsAdapter.prototype.destroy = function () {};

    /*
     * Dummy Dropdown adapter for noDropdown mode. (see below how noDropdown works)
     */
    const DummyDropdownAdapter = function () {
        DummyDropdownAdapter.__super__.constructor.call(this);
    }

    Utils.Extend(DummyDropdownAdapter, Utils.Observable);

    DummyDropdownAdapter.prototype.render = function () {};

    DummyDropdownAdapter.prototype.bind = function () {};

    DummyDropdownAdapter.prototype.position = function () {};

    DummyDropdownAdapter.prototype.destroy = function () {};

    /*
     * Override Defaults.apply() method to globally apply all our changes to Select2 components.
     */
    Defaults.constructor.prototype.apply = (function (decorated) {
        return function (options) {
            options = $.extend(true, {}, this.defaults, options);

            // Add a new Select2 option: noDropdown.
            //
            // When this option is enabled in combination with 'multiple', Select2 component will act like a
            // 'text array' field.
            //
            // In this configuration, Select2 component is very similar to the "Tagging with multi-value select boxes"
            // example of Select2 documentation (https://select2.org/tagging#tagging-with-multi-value-select-boxes)
            // with a few extra key points:
            //   - Server does not provide any option, only tags can be selected. In this context the Select2 dropdown
            //     is useless so we don't render it at all.
            //   - Duplicates of the same tag are allowed (this is normally not possible in Select2).
            if (options.noDropdown) {
                if (! options.multiple) {
                    console.log('Select2: noDropdown requires multiple.');
                } else {
                    // Set 'tags' option.
                    options.tags = true;

                    // Set our dummy Results and Dropdown adapters that do not render anything.
                    options.resultsAdapter = DummyResultsAdapter;
                    options.dropdownAdapter = DummyDropdownAdapter;

                    // This is the trick that allows duplicates of the same tags. Because the function that matches
                    // existing options with user input will always return false, any input will be considered as a new
                    // tag.
                    options.matcher = () => false;
                }
            }

            options = decorated.call(this, options);

            // Extend results adapter
            if (! options.noDropdown) {
                options.resultsAdapter = Utils.Decorate(options.resultsAdapter, ResultsExtension);
            }

            // Extend dropdown adapter
            if (! options.multiple) {
                options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, DropdownSearchExtension);
            }

            // Extend selection adapter
            options.selectionAdapter = Utils.Decorate(options.selectionAdapter, SelectionExtension);
            if (options.multiple) {
                options.selectionAdapter = Utils.Decorate(options.selectionAdapter, MultipleSelectionExtension);
            }

            return options;
        }
    })(Defaults.constructor.prototype.apply);
});

$.fn.select2.amd.require('select2.extension');
